import {
  InfoModule,
  createInfoServices
} from "./chunk-KGLVRYIC.mjs";
import "./chunk-K5T4RW27.mjs";
export {
  InfoModule,
  createInfoServices
};
